import { CUSTOMERAUTH_DETAIL_REQUEST, CUSTOMERAUTH_DETAIL_REQUEST_ERROR,UPDATE_ADMIN_STATUS,UPDATE_ECOM_DOMAIN } from "./constantTypes";


const initialAuthState = {
    isloggedIn: false,
    email:``,
    error: '',
    isAdmin: false,
    ecomDomain: ''
}
export const customerAuthReducer = (state = initialAuthState, action) => {
   
    switch (action.type) {
        case CUSTOMERAUTH_DETAIL_REQUEST:
            return {
                ...state,
                auth: action.payload,
                loading: false,
                error: ''
            }
        case CUSTOMERAUTH_DETAIL_REQUEST_ERROR:
            return {
                ...state,
                auth: {},
                loading: false,
                error: action.payload
            }
            case UPDATE_ADMIN_STATUS:
                return {
                    ...state,
                    auth: {
                        ...state.auth,
                        isAdmin: action.payload
                    }
                };
                case UPDATE_ECOM_DOMAIN:
            return {
                ...state,
                auth: {
                    ...state.auth,
                    ecomDomain: action.payload
                }
            };
        default:
           return state;
    }
}

